import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Profile} from '../profile.model';
import {Location} from '../../location/location.model';
import {endpoints} from '../../../core/configs/endpoints';

/**
 * Service to interact with the Profile API.
 * Provides methods to retrieve the users profile, loyalty, personal information etc.
 */
@Injectable({providedIn: 'root'})
export class ProfileApiService {
  private readonly _httpClient = inject(HttpClient)


  /**
   * Retrieves the profile of a specific user.
   * @returns An Observable emitting the user's profile.
   */
  public getProfile(): Observable<Profile> {
    return this._httpClient.get<Profile>(`${endpoints.user.detail}`);
  }

  public getLocations(): Observable<{ data: Location[] }> {
    return this._httpClient.get<{ data: Location[] }>(`${endpoints.location.list}`);
  }

  editProfile(data: any) {
    return this._httpClient.post(`${endpoints.user.update}`, data);
  }

  deleteProfile() {
    return this._httpClient.post(`${endpoints.user.delete}`, {});
  }
}
